import { AgendaSidebar } from "../components/AgendaSidebar"
import { triggerGamificationRule } from "../../utils/fw"

const between = (start, end) => new Date() > new Date(start) && new Date() < new Date(end)

export default {
	background: "https://assets.swoogo.com/uploads/full/5414273-683e095c32fdd.png",
	extras: (
		<>
			<iframe
				className="breakouts-livestream"
				src="https://www.youtube.com/embed/H41fuhz_gvw?si=VD_D7wycou1WbWk3&autoplay=1"
				title="YouTube video player"
				frameBorder="0"
				allowfullscreen
				allow="autoplay"
			/>
		</>
	),
	links: [
		{
			gameRule: "feedback-breakout-2",
			gameRuleCooldown: 1000 * 60 * 60,
			height: "9.4%",
			href: "https://isfcongress.tkeventsregistration.com/ffbr2",
			isExternal: true,
			label: "Feedback",
			left: "7.1%",
			target: "_blank",
			top: "31.6%",
			width: "10.4%",
		},
		{
			height: "15.7%",
			href: "https://isfcongress.tkeventsregistration.com/digital2021/ondemand",
			isExternal: true,
			label: "Access Content & On-Demand Videos",
			left: "7.1%",
			target: "_blank",
			top: "43.7%",
			width: "10.6%",
		},
		{
			height: "55.7%",
			label: "Breakout Two Screen",
			left: "25.4%",
			top: "8.5%",
			width: "49%",
		},
		{
			height: "46%",
			label: "What's on",
			left: "81.3%",
			top: "13.5%",
			width: "12.3%",
			children: <AgendaSidebar room="Breakout Two" />
		},
		{
			height: "16.8%",
			href: "/roundtables",
			label: "Roundtables",
			left: "45.5%",
			top: "81.8%",
			width: "9.4%",
		},
	],
	name: "breakout-two",
}
